// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"a61a22a1","605":"9033fb3b","809":"62452d41","981":"d0b64ee1"}[chunkId] + ".chunk.js";
};